import { BreakPoint } from '@makemydeal/dr-activities-common';
import { rem } from 'polished';
import styled from 'styled-components';

export const CreditBureauSeparator = styled.div`
    border-bottom: 0.1rem solid #c8c8c8;
`;
export const InterstateCreditBureauSeparator = styled.div`
    border-bottom: ${rem(1)} solid #b2b2b2;
    margin-bottom: ${rem(16)};
    margin: ${rem(37)} 0;
`;

export const CreditBureauContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;

    @media (min-width: ${BreakPoint.SMALL}) {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const TwoColumnLayout = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`;

export const CreditScoreConfigColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-top: 16px;
`;

export const CreditScoreConfigHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
`;

interface SoftPullPanelProps {
    backgroundColor?: string;
}

export const SoftPullPanel = styled.div<SoftPullPanelProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    padding: 16px 8px;
    border-radius: 4px;
    background-color: ${({ backgroundColor }) => backgroundColor ?? '#f4f4f4'};

    .ids-action.ids-action {
        font-size: 12px;
    }
`;

export const SoftPullScoreHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SoftPullScoreLabel = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CreditBureauLinkSection = styled.div`
    padding-top: 19px;
    width: 100%;
`;

export const CreditBureauDivider = styled.div`
    border-top: 1px solid #e0e0e0;
    margin-bottom: 8px;
`;
